/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Rail_NextInputs */

const en_platform_rail_next = /** @type {(inputs: Platform_Rail_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

const pl_platform_rail_next = /** @type {(inputs: Platform_Rail_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Następne`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Platform_Rail_NextInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_rail_next = /** @type {((inputs?: Platform_Rail_NextInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Rail_NextInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_rail_next(inputs)
	return en_platform_rail_next(inputs)
});